/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ErrorType = {
    APP: 'APP',
    API: 'API',
    FORM: 'FORM'
} as const;
export type ErrorType = typeof ErrorType[keyof typeof ErrorType];


export function instanceOfErrorType(value: any): boolean {
    for (const key in ErrorType) {
        if (Object.prototype.hasOwnProperty.call(ErrorType, key)) {
            if (ErrorType[key as keyof typeof ErrorType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ErrorTypeFromJSON(json: any): ErrorType {
    return ErrorTypeFromJSONTyped(json, false);
}

export function ErrorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorType {
    return json as ErrorType;
}

export function ErrorTypeToJSON(value?: ErrorType | null): any {
    return value as any;
}

export function ErrorTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ErrorType {
    return value as ErrorType;
}

